import axios from "axios";

const CRUD_KEY = "WTw0fEUjXau3J5e79L6iycALE2456sRef9i0vw5kU";
const CRUD_NAME = "console";

export const axiosWithConsoleCreds = (nonDefaultBaseURL) => {
    return axios.create({
        headers: {
            authorization: CRUD_NAME,
            "wsc-api-key": CRUD_KEY,
        },
        baseURL: nonDefaultBaseURL || "https://api.v3.invintusmedia.com",
    });
};

/**
 * Upload thumbnail to S3 and replace the event thumbnail
 * @param {Object} params
 * @param {string} params.clientID - Client ID
 * @param {string} params.assetID - Event asset ID
 * @param {File} params.file - Thumbnail image file
 * @param {string} params.eventID - Event ID
 * @param {string} params.path - Path to the image
 * @returns {Promise} API response
 */
export const replaceThumbnailWithUpload = async ({ clientID, assetID, file, eventID, path }) => {
    try {
        return new Promise(async (resolve, reject) => {
            // Step 1: Upload the file using Uppy
            const uppy = window.api.getUppy();
            
            if (!uppy) {
                return reject(new Error('Uppy instance not available'));
            }
            
            // Create a unique filename
            const filename = `${assetID}.jpg`;
            
            // Reset Uppy to avoid issues with previous uploads
            uppy.reset();
            
            // Add the file to Uppy with metadata to ensure it goes to client-images bucket
            uppy.addFile({
                name: filename,
                type: file.type || 'image/jpeg',
                data: file,
                size: file.size,
                meta: {
                    targetBucket: 'invintus-client-images',
                    targetRegion: 'us-east-1',
                    exactKey: `${clientID}/${filename}`,
                    noPlaceholder: true,
                    clientID,
                    eventID,
                    callback: async (file, res, err) => {
                        if (err) {
                            return reject(new Error('Failed to upload image: ' + err.message));
                        }

                        if (!res.data.valid) {
                            return reject(new Error('Invalid file: ' + res.data.message));
                        }
                        
                        try {
                            // Upload the file
                            const result = await uppy.upload();
                            
                            if (result.failed.length > 0) {
                                return reject(new Error('Failed to upload image: ' + (result.failed[0]?.error?.message || 'Unknown error')));
                            }
                            
                            if (!result.successful || result.successful.length === 0) {
                                return reject(new Error('No files were successfully uploaded'));
                            }
                            
                            const replaceThumbnailResponse = await replaceThumbnail({
                                clientID,
                                assetID,
                                path
                            });
                            
                            resolve(replaceThumbnailResponse);
                        } catch (uploadError) {
                            console.error("Error during upload or API call:", uploadError);
                            reject(uploadError);
                        }
                    }
                }
            });
         
        });
    } catch (error) {
        console.error("Error in replaceThumbnailWithUpload:", error);
        throw error;
    }
};

/**
 * Replace event thumbnail with an existing image
 * @param {Object} params
 * @param {string} params.clientID - Client ID
 * @param {string} params.assetID - Event asset ID 
 * @param {string} params.path - Path to the image
 * @returns {Promise} API response
 */
const replaceThumbnail = async ({ clientID, assetID, path }) => {
    const response = await axiosWithConsoleCreds(
        "https://crud.v3.invintusmedia.com"
    ).post(`/Thumbs/replaceUserImg`, {
        clientID,
        assetID,
        path
    });
    
    return response.data;
}; 